import css from 'styled-jsx/css';

const styles = css.global`#boleto-venceu {
  padding: 0 0 63px;
}

#boleto-venceu .boleto-venceu-desk {
  display: none;
}

#boleto-venceu picture, 
#boleto-venceu .img-boleto-venceu {
  width: 100%;
  height: 497px;
  object-fit: cover;
  object-position: top;
  border-radius: 4px;
}

#boleto-venceu .ctn-home-24 {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 32px;
}

#boleto-venceu .boleto-venceu-titulo {
  color: #C00;
  font-family: "SantanderHeadline";
  font-size: 48px;
  font-style: normal;
  font-weight: 400;
  line-height: 60px;
  margin: 0;
}

#boleto-venceu .boleto-venceu-texto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  max-width: 554px;
}

#boleto-venceu .boleto-venceu-texto a {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#boleto-venceu .boleto-venceu-texto b {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

#boleto-venceu .boleto-venceu-texto.margin-extra {
  margin: 16px 0;
}

#boleto-venceu .passos-gerar-boleto {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
}

#boleto-venceu .passo-gerar-boleto {
  color: #444;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
}

#boleto-venceu .passo-gerar-boleto b {
  color: #C00;
  font-family: "SantanderText";
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
}

#boleto-venceu .passo-gerar-boleto a {
  color: #C00;
  font-family: "SantanderText";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%;
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
}

#boleto-venceu .btn-boleto-venceu {
  width: 272px;
  height: 48px;
  margin: 32px auto 0;
}

@media (min-width: 992px) {
  #boleto-venceu {
    padding: 63px 0 95px;
  }

  #boleto-venceu .boleto-venceu-mobi {
    display: none;
  }

  #boleto-venceu .btn-boleto-venceu {
    margin: unset;
  }

  #boleto-venceu .boleto-venceu-desk {
    display: block;
  }

  #boleto-venceu .boleto-venceu-desk-conteudo {
    width: 100%;
  }

  #boleto-venceu .boleto-venceu-desk .ctn-home-24 {
    display: flex;
    flex-direction: row;
    gap: 72px;
  }

  #boleto-venceu picture, 
  #boleto-venceu .img-boleto-venceu {
    height: 623px;
  }

  #boleto-venceu .boleto-venceu-titulo {
    font-size: 72px;
    line-height: 120%;
  }
  #boleto-venceu .boleto-venceu-texto {
    margin-top: 24px;
  }

  #boleto-venceu .passos-gerar-boleto {
    display: flex;
    flex-direction: column;
    gap: 16px;
    margin-top: 49px;
  }
  
  #boleto-venceu .passo-gerar-boleto b {
    color: #C00;
    font-family: "SantanderText";
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 48px;
  }

  #boleto-venceu .passo-gerar-boleto a {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 140%;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
  }

  #boleto-venceu .btn-boleto-venceu {
    max-width: 100%;
    margin-top: 32px;
  }
}`;

export default styles;